
import React, { useEffect, useState } from 'react';
import { Navbar, Nav, Table, Dropdown } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';

function Quotations() {
    const { id } = useParams(); // Extract the customer ID from the URL
    const [quotations, setQuotations] = useState([]); // Updated to hold multiple quotations
    const [customerName, setCustomerName] = useState('');

    useEffect(() => {
        // Fetch quotations for the specific customer ID
        const fetchData = async () => {
            try {
                const response = await fetch(`https://marzdev.yourcrm.co.za/api/quotation/${id}`);
                const data = await response.json();

                // Check if the response contains an array of quotations
                if (data.Quotations) {
                    setQuotations(data.Quotations); // Set the quotations array
                    setCustomerName(data.customerName || 'Unknown');
                } else {
                    console.error('Expected an array of quotations');
                    setQuotations([]); // Fallback to an empty array if data is not found
                }
            } catch (error) {
                console.error('Error fetching quotations:', error);
                setQuotations([]); // Fallback to an empty array on error
            }
        };

        fetchData();
    }, [id]);

    return (
        <div>

            <div className="container mt-4">
                <h1>Quotations for {customerName}</h1>
                <p>Manage Quotations for the selected customer here.</p>

                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Date Created</th>
                            <th>Quotation ID</th>
                        </tr>
                    </thead>
                    <tbody>
                        {quotations.length > 0 ? (
                            quotations.map((quote, index) => (
                                <tr key={quote.QuotationID}>
                                    <td>{index + 1}</td>
                                    <td>{quote.DateCreated}</td>
                                    <td>
                                        <Link to={`/quotation/${id}/${quote.DateCreated}/${quote.QuotationID}`}>
                                            {quote.QuotationID}
                                        </Link>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="3">No Quotations available</td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>
        </div>
    );
}

export default Quotations;
